import React from 'react';
import styles from './staff.module.scss';
import { ReactComponent as Hat } from '../../static/icon-hat.svg';
import { ReactComponent as Phone } from '../../static/icon-phone.svg';
import { ReactComponent as Email } from '../../static/icon-email.svg';

interface StaffMemberProps {
  data: {
    name?: string;
    phone?: string;
    email?: string;
    role?: string;
  };
}

const StaffMember: React.FC<StaffMemberProps> = ({ data }) => {
  return (
    <>
      <div className={styles.staffMember}>
        <h3>{data.name}</h3>
        <ul>
          {data.role && (
            <li className={styles.role}>
              <Hat />
              {data.role}
            </li>
          )}
          {data.phone && (
            <li className={styles.phone}>
              <Phone />
              {data.phone}
            </li>
          )}
          {data.email && (
            <li className={styles.email}>
              <Email />
              {data.email}
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default StaffMember;
